var _path, _path2, _mask, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileAviInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85489 1.86879L14.0589 0L43.1724 22.8426L43.8904 24.7895C44.3474 26.3681 44.0863 28.0729 43.1724 29.4621C42.3238 30.8512 40.8877 31.8615 39.2558 32.2403L14.0589 38.1757C13.602 38.302 13.0798 38.3652 12.5576 38.3652C11.3826 38.3652 10.2729 38.0495 9.22844 37.4812C7.79235 36.6603 6.74792 35.2712 6.35626 33.6926L0.220234 9.31961C-0.236704 7.74105 0.0244029 6.0362 0.938279 4.64706C1.78688 3.25793 3.22297 2.24765 4.85489 1.86879Z",
    transform: "translate(0.220215 38.9499) scale(1 -1)",
    fill: "#201F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19486 0H40.2912C44.2295 0 47.4861 3.18182 47.4861 7.19697V40.303C47.4861 44.2424 44.3052 47.5 40.2912 47.5H7.19486C3.25662 47.5 0 44.3182 0 40.303V7.19697C0 3.25758 3.18089 0 7.19486 0Z",
    transform: "translate(11.1802 59.04) scale(1 -1)",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "file-avi-inner_svg__file-avi-inner_svg__mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 48,
    height: 49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.19486 0H40.2912C44.2295 0 47.4861 3.18182 47.4861 7.19697V40.303C47.4861 44.2424 44.3052 47.5 40.2912 47.5H7.19486C3.25662 47.5 0 44.3182 0 40.303V7.19697C0 3.25758 3.18089 0 7.19486 0Z",
    transform: "translate(11.1802 59.04) scale(1 -1)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file-avi-inner_svg__file-avi-inner_svg__mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3788 0H9.28247V4.17522H42.3788V0ZM9.28247 0C4.10068 0 0 4.20715 0 9.28458H4.17522C4.17522 6.48322 6.43631 4.17522 9.28247 4.17522V0ZM0 9.28458V42.3906H4.17522V9.28458H0ZM0 42.3906C0 47.5725 4.20504 51.6752 9.28247 51.6752V47.5C6.48343 47.5 4.17522 45.2391 4.17522 42.3906H0ZM9.28247 51.6752H42.3788V47.5H9.28247V51.6752ZM42.3788 51.6752C47.5606 51.6752 51.6613 47.4681 51.6613 42.3906H47.4861C47.4861 45.192 45.225 47.5 42.3788 47.5V51.6752ZM51.6613 42.3906V9.28458H47.4861V42.3906H51.6613ZM51.6613 9.28458C51.6613 4.10276 47.4563 0 42.3788 0V4.17522C45.1779 4.17522 47.4861 6.4361 47.4861 9.28458H51.6613Z",
    transform: "translate(9.09229 61.1276) scale(1 -1)",
    fill: "#201F1F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(17.8701 52.61) scale(1 -1)",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(17.8701 44.97) scale(1 -1)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(17.8701 37.4) scale(1 -1)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59913H3.72078V0Z",
    transform: "translate(17.8701 29.76) scale(1 -1)",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(47.7002 52.61) scale(1 -1)",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(47.7002 44.97) scale(1 -1)",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59912H3.72078V0Z",
    transform: "translate(47.7002 37.4) scale(1 -1)",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59913H3.72078V0Z",
    transform: "translate(47.7002 29.76) scale(1 -1)",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59913H3.72078V0Z",
    transform: "translate(17.8701 22.45) scale(1 -1)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72078 0H0V3.59913H3.72078V0Z",
    transform: "translate(47.7002 22.45) scale(1 -1)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.718045 15.9435C0.587491 15.9435 0.456936 15.9435 0.39166 15.8803C0.130552 15.7541 0 15.5015 0 15.2489V0.72614C0 0.47357 0.130552 0.220999 0.39166 0.0947138C0.652767 -0.0315713 0.913877 -0.0315713 1.10971 0.0947138L13.3165 7.35611C13.5123 7.48239 13.6429 7.73496 13.6429 7.98753C13.6429 8.2401 13.5123 8.42953 13.3165 8.61896L1.10971 15.8172C0.979153 15.8803 0.848598 15.9435 0.718045 15.9435Z",
    transform: "translate(28.71 43.36) scale(1 -1)",
    fill: "#C3272F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAviInner);
export default __webpack_public_path__ + "static/media/file-avi-inner.91868bd1ef581a511b08462f332f2936.svg";
export { ForwardRef as ReactComponent };